import {EMMAI_FORMS} from '../../../../../../../const';
import serializeDentalOffice from '../../../EmmaiDentalOfficeForm/helpers/serializeDentalOffice';
import {serializeAllPractitionersActivities} from '../../../EmmaiPractitionerActivityInformationForm/helpers/serializePractitionerActivity';

export default function useSubmitMonthlyRestitution({currentForm, emmaiData, selectedProject, formattedEmmaiRestitutionSelectedDate, methods, addActivities}) {
  const {isDirty, isSubmitting} = methods.formState;
  const submitDisabled = !isDirty || isSubmitting || currentForm === EMMAI_FORMS.ADD_OR_UPDATE_PRACTITIONER || (emmaiData.practitioners || []).length === 0;

  const onSubmit = async data => {
    const apiFormattedDentalOfficeInfo = serializeDentalOffice(data.officeInformation);
    const apiFormattedActivities = serializeAllPractitionersActivities(data.practitionerActivity, selectedProject.siren, formattedEmmaiRestitutionSelectedDate);

    const res = await addActivities({
      dentalOfficeInfo: [
        {
          ...apiFormattedDentalOfficeInfo,
          siren: selectedProject.siren,
          period: formattedEmmaiRestitutionSelectedDate
        }
      ],
      practitionerActivities: apiFormattedActivities
    });
    if (res.success) {
      methods.reset(data);
    }
  };

  return {
    submitDisabled,
    onSubmit
  };
}
